import { forwardRef } from 'react';
import { StyledInline } from './styled';

const Inline = forwardRef((props, ref) => (
  <StyledInline ref={ref} {...props} />
));

export default Inline;
